import { render } from "./LabeledInput.vue?vue&type=template&id=67784170&scoped=true"
import script from "./LabeledInput.vue?vue&type=script&lang=js"
export * from "./LabeledInput.vue?vue&type=script&lang=js"

import "./LabeledInput.vue?vue&type=style&index=0&id=67784170&scoped=true&lang=css"
import "./LabeledInput.vue?vue&type=style&index=1&id=67784170&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67784170"]])

export default __exports__